import { render, staticRenderFns } from "./friend-add-dialog.vue?vue&type=template&id=2d25c48d&scoped=true"
import script from "./friend-add-dialog.vue?vue&type=script&lang=js"
export * from "./friend-add-dialog.vue?vue&type=script&lang=js"
import style0 from "./friend-add-dialog.vue?vue&type=style&index=0&id=2d25c48d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d25c48d",
  null
  
)

export default component.exports